import type { PwaController } from "./PwaController";
import { pwaController } from "./defaultPwaController";
import { PwaStatusNotice } from "./PwaStatusNotice";
import { usePwaStatus } from "./usePwaStatus";

export interface PwaStatusAdapterProps {
  controller?: PwaController;
}

export function PwaStatusAdapter({
  controller = pwaController
}: PwaStatusAdapterProps) {
  const { status, dismissCacheFailure } = usePwaStatus({
    controller
  });

  return (
    <PwaStatusNotice
      status={status}
      onDismissCacheFailure={dismissCacheFailure}
    />
  );
}
